import { memo, useCallback } from 'react';

import CustomCheckbox from '@/components/Checkbox';
import type { SymbolKey } from '@/entities/symbol';
import { isSameSymbol, isSameSymbolIgnoringPeriod } from '@/entities/symbol';
import { toggleSymbol } from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';

const SymbolCheckboxComponent = ({
  symbol,
  disabled
}: {
  symbol: SymbolKey;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const isForwardMode = useAppSelector(state => state.symbolSelector.isForwardMode);

  // Subscribe to just the boolean selected state for this specific symbol.
  const isChecked = useAppSelector(state => {
    const equals = isForwardMode ? isSameSymbolIgnoringPeriod : isSameSymbol;
    return state.symbolSelector.symbols.some(s => equals(s, symbol));
  });

  const handleChange = useCallback(() => {
    dispatch(toggleSymbol({ symbol }));
  }, [dispatch, symbol]);

  return (
    <CustomCheckbox
      checked={isChecked}
      disabled={disabled}
      onChange={handleChange}
    />
  );
};

export const SymbolCheckbox = memo(SymbolCheckboxComponent);
